//This code looks for inputs and selects in a form and checks their validity
export function validateForm(theForm) {
  const inputs = theForm.querySelectorAll("input, select");
  let isValid = true;
  inputs.forEach((element) => {
    element.checkValidity();
    if (!element.checkValidity()) {
      isValid = false;
    }
  });
  return isValid;
}

export function validateInput(element) {
  let isValid = true;

  element.checkValidity();
  if (!element.checkValidity()) {
    isValid = false;
  }

  return isValid;
}

//Function to display the date in US format but UTC date from server
export function displayUtcDate(utcdate) {
  let theDate = new Date(utcdate);
  let returnedDate = theDate.getFullYear() + "-" + (theDate.getUTCMonth() + 1) + "-" + theDate.getUTCDate();

  return returnedDate;
}
